module.exports = __webpack_public_path__ + "static/media/intro.7125183d.mp3";